/** @jsxImportSource @emotion/react */
import React from "react";
import { Text } from "../../../general/Text";
import LoadingEllipse from "../../../ButterComponents/LoadingEllipse/LoadingEllipse";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import styled from "@emotion/styled";

export const ConfirmInWallet: React.FC<{
  isVisible: boolean;
  confirmOrApproveText: string;
}> = ({ isVisible, confirmOrApproveText }) => {
  const theme = GlobalStore.useState(s => s.theme);
  if (!isVisible) {
    return null;
  }
  return (
    <ConfirmInWalletContainer>
      <LoadingEllipse />
      <Text textStyle="Paragraph" size="Large" color={theme.font.primary.default}>
        {confirmOrApproveText} in wallet
      </Text>
    </ConfirmInWalletContainer>
  );
};

const ConfirmInWalletContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
`;
